import { useState } from 'react'
import logo from 'images/farmtrx-logo-ondark.png'
import { Link } from 'react-router'
import { useTheme } from '@mui/material/styles'
import { getPartnerLogoUrl, getPartnerReverseLogoUrl } from 'common/misc'
import { LOGO_STAGES, nextLogoStage } from 'components/logo-stages'

export default function Logo() {
  const theme = useTheme()
  const [stage, setStage] = useState(LOGO_STAGES[0])

  const advanceStage = () => setStage(nextLogoStage)

  return (
    <Link
      style={{
        zIndex: theme.zIndex.drawer + 1,
        width: '250px',
        flex: '0 0 auto',
      }}
      to={{ pathname: '/' }}
      target="_blank"
    >
      {stage === 'bundled' ? (
        <img width="100" height="17" src={logo} style={{ maxWidth: '100px' }} />
      ) : (
        <img
          src={
            stage === 'reverse'
              ? getPartnerReverseLogoUrl()
              : getPartnerLogoUrl()
          }
          style={{ maxWidth: '100px', maxHeight: '36px' }}
          onError={advanceStage}
        />
      )}
    </Link>
  )
}
